import axios_c_low from "src/service/axios_c_low";
import CartConfig from "@system/config/cart";
import CartRepository from "../repository/CartRepository";
import store from "../storeWire";
import { system_notification } from "../store/slice/system";
import Base from "./Base";
import Auth from "@system/config/auth";
import { __remove, __set } from "../store/axios_indicator";
import liveAuth from "../helper/liveAuth";
import ResponseMaker from "./Cart/responseMaker";
import ReplaceCartResponseMaker from "./Cart/replaceCartResponseMaker";
import ProductRepository from "../repository/ProductRepository";
import Helper from "src/support/Helper";
import System from "src/helper/system";
import Constants from "src/support/Constants";

class Cart extends Base {
    getCartCount = async () => {
        let res = {
            data: {
                count: 0
            }
        };
        if (liveAuth.permit('PD_VIEW_CART').status === false) {
            return res;
        }
        if (liveAuth.check()) {
            await this.axiosCall(CartConfig.CART_COUNT).then((resHer) => {
                res = resHer.data;
            }).catch(() => {
                __remove('CART_API_CALL');
            });
        }
        return res;
    };
    addCartInBulk = async (params) => {
        __set('CART_OPERATION_API_CALL');
        let res = {};
        await this.axiosCall(CartConfig.ADD_TO_CART_IN_BULK, params, 'post', true).then((resHer) => {
            res = resHer.data;
        });
        __remove('CART_OPERATION_API_CALL');
        return res;
    };
    addToCartServer = async (params) => {
        __set('CART_OPERATION_API_CALL');

        let res = {};
        params.currency = window.mct;
        await this.axiosCall(CartConfig.ADD_TO_CART, params).then((resHer) => {
            res = resHer.data;
            sessionStorage.setItem(params.partNumber, params.cpn)

        }).catch(() => {
            __remove('CART_OPERATION_API_CALL');
        });
        __remove('CART_OPERATION_API_CALL');
        return await this.validateResponse(res);
    };
    updateToCartServer = async (params) => {
        let data_current = new CartRepository().getCartItemByCartDetailID(params.cartDetailId);

        if (data_current === false) {
            return;
        }
        let _data = Helper.sanitizeCartDataToUpdate(data_current);
        if (_data.subtotal) {
            delete _data.subtotal
        }
        let data = {
            ..._data,
            ...params
        };
        __set('CART_OPERATION_API_CALL');
        let res = {};
        await this.axiosCall(CartConfig.UPDATE_TO_CART, data, 'put', false, false, true).then((resHer) => {
            res = resHer.data;
        });
        __remove('CART_OPERATION_API_CALL');
        return await this.validateResponse(res);
    };
    /**
     * comment due to cart error need uncomment for update cart optimization
     * Author: Devanshi Patel
     */
    updateCartItemsServer = async (params) => {
        let res = {};
        await this.axiosCall(CartConfig.UPDATE_CART_ITEMS_BULK, params, 'post', true).then(resHer => {
            res = resHer.data
        })
        return await this.validateResponse(res);
    }
    updateReferencePartNumberByCartDetailID = async (cartDetailId, referencePartNumber = null) => {
        let data_current = new CartRepository().getCartItemByCartDetailID(cartDetailId);
        if (data_current === false) {
            return;
        }

        let _data = Helper.sanitizeCartDataToUpdate(data_current);
        let data = {
            ..._data,
            cartDetailId, referencePartNumber
        };


        await this.axiosCall(CartConfig.UPDATE_TO_CART, data, 'put');
    };
    updateBackOrderQuantityToCartServer = async (params) => {
        __set('CART_OPERATION_API_CALL');
        let res = {};
        await this.axiosCall(CartConfig.UPDATE_BACKORDER_QUANTITY_TO_CART, params, 'POST', true).then((resHer) => {
            res = resHer.data;
        });
        __remove('CART_OPERATION_API_CALL');
        return await this.validateResponse(res);
    };
    /*
    validaCart this is useless param added just because backend API demanded to call CartConfig.VALIDATE_CART
    instead of CartConfig.VIEW_CART in some places
    */
    getCartFromServer = async (params, validaCart = false) => {
        let cart = new CartRepository();
        let res = {};
        if (!liveAuth.check()) {
            return res;
        }
        if (liveAuth.permit('PD_VIEW_CART').status === false) {
            return res;
        }
        __set('VIEW_CART_API_CALL');
        await this.axiosCall(validaCart ? CartConfig.VALIDATE_CART : CartConfig.VIEW_CART, params).then((resHer) => {
            if (resHer?.data?.data) {
                if (resHer.data.data.cartItems) {
                    res.data = resHer.data.data.cartItems;
                } else {
                    res.data = {};
                }
                if (resHer.data.data.shipToAddressId !== undefined) {
                    res.shipToAddressId = resHer.data.data.shipToAddressId;
                } else {
                    res.shipToAddressId = false;
                }
                if (resHer.data.data.orderId) {
                    cart.setWebOrderID(resHer.data.data.orderId)
                }
            }
        }).catch(() => {
            /**
             * remove it because of bug solving bug if there are need any more changes we need to do currently we make validate to false
             */
            let state = store.getState();
            if (state.entities.Cart.CART_SHIPPING_ADDRESS_ID !== undefined &&
                (
                    state.entities.Cart.CART_SHIPPING_ADDRESS_ID === null ||
                    state.entities.Cart.CART_SHIPPING_ADDRESS_ID === ''
                ) &&
                state.entities.auth.SHIPPING_ADDRESS_LIST !== undefined &&
                state.entities.auth.SHIPPING_ADDRESS_LIST.length > 0
            ) {
                store.dispatch(system_notification({
                    name: 'ShippingAddressPopup',
                    data: [],
                }));
            }
        });

        let cartId = false;
        try {
            cartId = res.data[0].cartId
        } catch (e) {
        }
        if (cartId === false && res?.data && res.data?.cartId) {
            cartId = res.data.cartId;
        }
        if (cartId) {
            await cart.setCartID(cartId);
        }

        const resMak = new ResponseMaker(await this.validateResponse(res)).process().run().get();
        setTimeout(() => {
            __remove('VIEW_CART_API_CALL');
        }, 2000);
        return resMak
    };
    clearAllCartFromServer = async () => {
        let res = {};
        await this.axiosCall(CartConfig.COMPLETELY_CLEAR_CART, {}, 'delete').then((resHer) => {
            res = resHer.data;
        });
        return res;
    };
    clearSingleCartProductFromFromServerByCartDetailId = async (cartDetailId) => {
        let res = {};
        await this.axiosCall(CartConfig.CLEAR_SINGLE_PRODUCT_FROM_CART, {
            cartDetailId: cartDetailId
        }, 'delete').then((resHer) => {
            res = resHer.data;
        });
        return res;
    };
    axiosCall = async (url, data = {}, method = 'post', skipParams = false, isBlob = false, skipMergeData = false) => {
        if (!skipMergeData) {
            data = await this.mergeDataWithBase(data);
        }

        let config = {
            method: method,
            url: url,
            headers: Helper.getCommonHeader(method),
            data: data
        };
        if (skipParams === false && (config.method !== 'post' && config.method !== 'POST')) {
            config.params = data;
        }
        // Set Response Type as Blob

        if (isBlob) {
            config.responseType = 'blob';
        }
        return axios_c_low(config);
    };
    mergeDataWithBase = async (data) => {
        let cart = new CartRepository();
        data.userId = await Auth.getUserID();
        if (!data.cartId && data?.type !== 'Quote') {
            data.cartId = await cart.getCartID();
        }
        if (data.backOrderQuantity !== undefined) {
            data.backOrderedQuantity = data.backOrderQuantity;
        }
        if (data.CUSTOMER_PART_NUMBER !== undefined) {
            data.cpn = data.CUSTOMER_PART_NUMBER;
        }
        if (data.partNumber && ProductRepository.detectStringIsItemNumber(data.partNumber)) {
            data.partNumber = '';
        }
        if (!data.shipToAddressId) {
            let state = store.getState();
            if (state.entities.Cart.CART_SHIPPING_ADDRESS_ID) {
                data.shipToAddressId = state.entities.Cart.CART_SHIPPING_ADDRESS_ID;
            }
        }
        return data;
    };
    validateResponse = async (data) => {
        if (!data.data.partNumber || data.data.partNumber === '' || data.data.partNumber === '' || data.data.partNumber === '0') {
            data.data.partNumber = data.data.itemNumber;
        }
        return data;
    };

    scheduleShippingApply = async (params) => {
        let res = {};
        await this.axiosCall(CartConfig.SCHEDULE_SHIPPING_APPLY, params, 'POST', true).then((resHer) => {
            res = resHer.data;
        });
        return res;
    };

    exportCartData = async (fileType) => {
        let open_pdf_detected = false;
        if (fileType === 'open_pdf') {
            open_pdf_detected = true;
            fileType = 'pdf'
        }
        const params = {
            "fileType": fileType,
            "type": "Shopping",
        };
        await this.axiosCall(CartConfig.EXPORT_CART_DATA, params, 'post', true, true, true).then((response) => {
            if (open_pdf_detected === true) {
                var file = new Blob([response.data], { type: 'application/pdf' });
                var fileURL = URL.createObjectURL(file);
                var blobURL = fileURL;
                let iframe = document.createElement('iframe'); //load content in an iframe to print later
                document.body.appendChild(iframe);
                iframe.style.display = 'none';
                iframe.src = blobURL;
                iframe.onload = function () {
                    setTimeout(function () {
                        iframe.focus();
                        iframe.contentWindow.print();
                    }, 1);
                };
                System.alert(Constants.downloadMsg, 'success', 'exportCartMsg')
                return;
            }
            if (response.data !== undefined && response.data !== null) {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'Cart.' + params.fileType);
                document.body.appendChild(link);
                link.click();
                System.alert(Constants.downloadMsg, 'success', 'exportCartMsg')
            }
        })
    };

    // getVatData = async () => {
    //     return false;
    //     let res = "";
    //     let URL = CartConfig.GET_VAT_DATA + '?countryCode=' + await Auth.getCountryCode()
    //     await this.axiosCall(URL, {}, 'GET', true).then((resHer) => {
    //         res = resHer && resHer.data && resHer.data.data && resHer.data.data.vatValue;
    //     }).catch((e) => {
    //         res = "00.00"
    //     });
    //     //return res;
    //     return 0;
    // };

    getMrfCodeToValidateToShip = async (countryCode) => {
        let res = "";
        const params = { countryCode: countryCode };
        let URL = CartConfig.VALIDATE_TO_SHIP;

        await this.axiosCall(URL, params, 'POST', false).then((resHer) => {
            res = resHer.data;
        });

        return res;

    };

    checkItemExistsInCart = async (params) => {
        let res = ''
        __set('CHECK_CART_ITEM_EXIST');
        await this.axiosCall(CartConfig.CHECK_CART_ITEM_EXIST, params, 'POST', true).then((resHer) => {
            res = resHer && resHer.data && resHer.data.data && resHer.data.data.itemsExists
        }).catch((e) => {
            console.log(e)
            res = false
        });
        __remove('CHECK_CART_ITEM_EXIST');
        return res;
    };

    replaceCartInBulk = async (params) => {
        let res = {};
        await this.axiosCall(CartConfig.REPLACE_TO_CART_IN_BULK, params, 'post', true).then((resHer) => {
            res = resHer.data;
        });
        return new ReplaceCartResponseMaker(res).process().run().get();
    };

    // checkItemsForBlackListedCountry = async(params) => {
    //     let res = ''
    //     await this.axiosCall(CartConfig.CHECK_ITEM_FOR_BLACKLIST_COUNTRY, params, 'POST', false).then((resHer) => {
    //         res = resHer && resHer.data && resHer.data;
    //     }).catch((e) => {
    //         console.log(e)
    //         res = false
    //     });
    //     return res;
    // }

    getCheckoutCharge = async (params) => {
        let res = ''
        await this.axiosCall(CartConfig.CHECKOUT_CHARGE, params, 'POST', true).then((resHer) => {
            res = resHer.data.data && resHer.data.data
        }).catch((e) => {
            console.log(e)
            res = false
        });
        return res;
    };

}

export default Cart;